import React, { useCallback, useEffect, useRef, useState } from 'react';
import moment from 'moment';
import './css/AdminPanel.css';
import { getAllUsers } from '../../Utils/RestUtils';
import {
  EMPTY_VALUE,
  USERS_SEARCH_PLACEHOLDER,
  USERS_TOTAL,
  USER_EMAIL,
  USER_REGISTRATION_DATE,
  NO_USERS,
} from '../../Utils/Constants/AdminConstants';
import AdminUserModal from './AdminUserModal/AdminUserModal';

function Users() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const [isUserModalVisible, setIsUserModalVisible] = useState(false);
  const userModalNode = useRef(null);

  useEffect(() => {
    const token = window.localStorage.getItem('accessToken');

    getAllUsers(token)
      .then((response) => {
        if (response && response.data) {
          setUsers(response.data);
        }
      })
      .catch(() => {});
  }, []);

  const closeUserModal = useCallback(() => {
    setIsUserModalVisible(false);
  }, []);

  const removeUser = (userId) => {
    closeUserModal();
    setUsers((prevUsers) => prevUsers.filter((user) => user.id !== userId));
  };

  const openUserModal = (user) => {
    setSelectedUser(user);
    setIsUserModalVisible(true);
  };

  useEffect(() => {
    if (!isUserModalVisible) {
      return undefined;
    }

    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    // the opening click reaches document after this effect runs (React 18)
    const handleOutsideClick = (e) => {
      const node = userModalNode.current;

      if (
        !node ||
        !e.target.isConnected ||
        node.contains(e.target) ||
        e.target.closest('.ap_users_line') ||
        e.target.closest('.aom_top')
      ) {
        return;
      }

      closeUserModal();
    };

    document.addEventListener('click', handleOutsideClick, false);

    return () => {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.removeEventListener('click', handleOutsideClick, false);
    };
  }, [isUserModalVisible, closeUserModal]);

  const getDateText = (date) => {
    if (!date) {
      return EMPTY_VALUE;
    }

    return moment(date).format('DD.MM.YYYY HH:mm');
  };

  const searchValue = search.trim().toLowerCase();
  const filteredUsers = users.filter(
    (user) => user.email && user.email.toLowerCase().includes(searchValue),
  );

  const renderUsers = () =>
    filteredUsers.map((user) => (
      <button
        key={`ap-user-${user.id}`}
        type="button"
        className="ap_table_line ap_table_link ap_users_line"
        onClick={() => openUserModal(user)}
      >
        <div className="ap_users_col_email dbm_text_16">{user.email}</div>
        <div className="ap_users_col br_text_16">
          {getDateText(user.registrationDate)}
        </div>
      </button>
    ));

  return (
    <div className="ap_card">
      <div className="ap_users_toolbar">
        <input
          className="ap_text_input ap_users_search"
          type="text"
          value={search}
          placeholder={USERS_SEARCH_PLACEHOLDER}
          onChange={(e) => setSearch(e.target.value)}
        />
        <div className="gr_text_16">
          {`${USERS_TOTAL}: ${filteredUsers.length}`}
        </div>
      </div>
      <div className="ap_table_head">
        <div className="ap_users_col_email gm_text_14">{USER_EMAIL}</div>
        <div className="ap_users_col gm_text_14">{USER_REGISTRATION_DATE}</div>
      </div>
      {filteredUsers.length > 0 ? (
        renderUsers()
      ) : (
        <div className="ap_table_empty gr_text_16">{NO_USERS}</div>
      )}
      <AdminUserModal
        isVisible={isUserModalVisible}
        modalNode={userModalNode}
        handleModalClick={closeUserModal}
        user={selectedUser}
        handleUserDelete={removeUser}
      />
    </div>
  );
}

export default Users;
